// src/components/mre-banner/banner.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment UILinkActionFragment on UILinkAction {\n    resource {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    accessibility\n    action {\n      ...UILinkActionFragment\n    }\n    disabled\n    primary\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment ActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    resource {\n      value\n    }\n    target\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      ...ActionFragment\n    }\n    size\n    text\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    weight\n    theme\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSStandardLinkFragment\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment MreBannerViewFragment on mreContents {\n    image {\n      description\n      url\n    }\n    heading {\n      ...EGDSStylizedTextFragment\n    }\n    body {\n      ...EGDSStylizedTextFragment\n    }\n    inLineLink {\n      ...EGDSStandardLinkFragment\n    }\n    button {\n      ...EGDSButtonFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  query MREBannerQuery($context: ContextInput!, $lob: String!, $pageType: String!) {\n    mreQuery(context: $context, lob: $lob, pageType: $pageType) {\n      body {\n        ...EGDSStylizedTextFragment\n      }\n      button {\n        ...EGDSButtonFragment\n      }\n      heading {\n        ...EGDSStylizedTextFragment\n      }\n      image {\n        description\n        url\n      }\n      inLineLink {\n        ...EGDSStandardLinkFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
import React6 from "react";
import { gql as gql9, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/egds-button/egds-button.tsx
import React from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/common/client-side-analytics.ts
import { gql } from "@apollo/client";
var clientSideAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/ui-link-action/lodging-ui-link-action.ts
import { gql as gql2 } from "@apollo/client";
var _obj;
// ../internal/src/components/common/uitk-link-target-mapper.tsx
var UILinkTargetMap = (_obj = {}, _define_property(_obj, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj, "INTERNAL" /* INTERNAL */ , "_self"), _obj);
// ../internal/src/components/ui-link-action/lodging-ui-link-action.ts
var fragment = gql2(_templateObject1());
var getUILinkActionPath = function(action) {
    if (action.resource.__typename !== "HttpURI") {
        return null;
    }
    return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getUILinkActionTarget = function(action) {
    return UILinkTargetMap[action.target];
};
// ../internal/src/components/egds-button/egds-button.tsx
var fragment2 = gql3(_templateObject2(), fragment, clientSideAnalyticsFragment);
var deriveLinkProps = function(action) {
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getUILinkActionTarget(action),
        tag: "a"
    };
};
var buttonComponents = {
    UIPrimaryButton: EGDSPrimaryButton,
    UISecondaryButton: EGDSSecondaryButton,
    UITertiaryButton: EGDSTertiaryButton
};
var EGDSButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, __typename = _param_data.__typename, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, dataStid = _param.dataStid, props = _object_without_properties(_param, [
        "onClick",
        "data",
        "dataStid"
    ]);
    var linkProps = deriveLinkProps(action);
    var track = useClickTracker();
    var handleClick = React.useCallback(function(event) {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        analytics,
        onClick,
        track
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, disabled ? {} : linkProps, props);
    var Button = buttonComponents[__typename];
    if (Button) {
        return /* @__PURE__ */ React.createElement(Button, _object_spread_props(_object_spread({}, buttonProps), {
            "data-stid": dataStid
        }), primary);
    }
    return null;
};
EGDSButton.fragment = fragment2;
EGDSButton.displayName = "EGDSButton";
// ../internal/src/components/egds-text/egds-text.tsx
import React4 from "react";
import { gql as gql7 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React2 from "react";
import { gql as gql5 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
var _obj1;
// ../internal/src/components/common/link-map.tsx
var linkSizeMapper = (_obj1 = {}, _define_property(_obj1, "SMALL" /* SMALL */ , "small"), _define_property(_obj1, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj1, "LARGE" /* LARGE */ , "large"), _obj1);
var _obj2;
var UILinkTargetMap2 = (_obj2 = {}, _define_property(_obj2, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj2, "INTERNAL" /* INTERNAL */ , "_self"), _obj2);
// ../internal/src/components/egds-text/__private/link-action.tsx
import { gql as gql4 } from "@apollo/client";
var UILinkActionFragment = gql4(_templateObject3());
// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment3 = gql5(_templateObject4(), UILinkActionFragment);
var EGDSStandardLink = function(param) {
    var className = param.className, inline = param.inline, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, size = _param_data.size, text = _param_data.text;
    var clickTracker = useClickTracker2();
    var onClick = React2.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React2.createElement(UitkLink, {
        className: className,
        size: linkSizeMapper[size],
        onClickCapture: onClick,
        inline: inline
    }, /* @__PURE__ */ React2.createElement("a", {
        href: resource.value,
        target: UILinkTargetMap2[target]
    }, text, accessibility && /* @__PURE__ */ React2.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = fragment3;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React3 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkText } from "uitk-react-text";
var _obj3;
// ../internal/src/components/common/text-utils.tsx
var textThemeMapper = (_obj3 = {}, _define_property(_obj3, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj3, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj3, "INVERSE" /* INVERSE */ , "inverse"), _define_property(_obj3, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj3, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj3, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj3, "SECONDARY" /* SECONDARY */ , "default"), _obj3);
var _obj4;
var textWeightMapper = (_obj4 = {}, _define_property(_obj4, "BOLD" /* BOLD */ , "bold"), _define_property(_obj4, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj4, "REGULAR" /* REGULAR */ , "regular"), _obj4);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment4 = gql6(_templateObject5());
var EGDSStylizedText = function(param) {
    var _param_data = param.data, text = _param_data.text, weight = _param_data.weight, theme = _param_data.theme, size = param.size, inline = param.inline;
    var themeProps = theme ? textThemeMapper[theme] : void 0;
    var weightProps = weight ? textWeightMapper[weight] : void 0;
    return /* @__PURE__ */ React3.createElement(UitkText, {
        weight: weightProps,
        size: size,
        inline: inline,
        theme: themeProps
    }, text);
};
EGDSStylizedText.fragment = fragment4;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment5 = gql7(_templateObject6(), EGDSStylizedText.fragment, EGDSStandardLink.fragment);
var EGDSText = function(param) {
    var data = param.data, size = param.size, inline = param.inline, className = param.className;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React4.createElement(EGDSStylizedText, {
                data: data,
                size: size,
                inline: inline
            });
        case "EGDSStandardLink":
            return /* @__PURE__ */ React4.createElement(EGDSStandardLink, {
                className: className,
                data: data,
                inline: inline
            });
        default:
            return null;
    }
};
EGDSText.fragment = fragment5;
EGDSText.displayName = "EGDSText";
// src/components/mre-banner/__private/components/__fragments/mre-banner-view.tsx
import React5 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSFigure, EGDSImage } from "@egds/react-core/images";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { ITrackType, useClickstreamAnalytics, useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var mreBannerViewFragment = gql8(_templateObject7(), EGDSStylizedText.fragment, EGDSStandardLink.fragment, EGDSButton.fragment, fragment);
var MreBannerView = function(param) {
    var data = param.data;
    var _data_inLineLink;
    var linkAnalytics = (_data_inLineLink = data.inLineLink) === null || _data_inLineLink === void 0 ? void 0 : _data_inLineLink.action.analytics;
    var clickTracker = useClickTracker3();
    var onLinkClick = React5.useCallback(function() {
        if (linkAnalytics) {
            clickTracker(linkAnalytics.referrerId, linkAnalytics.linkName);
        }
    }, [
        clickTracker,
        linkAnalytics
    ]);
    var track = useClickstreamAnalytics().track;
    React5.useEffect(function() {
        var transformedUISMessage = [
            {
                messageContent: JSON.parse('{"moduleContent":"mre_banner.presented"}'),
                schemaName: "mreView"
            }
        ];
        track(ITrackType.EVENT, {
            data: transformedUISMessage
        });
    }, []);
    var renderMreBannerView = function(param) {
        var type = param.type;
        var _data_image, _data_image1, _data_heading, _data_body;
        return /* @__PURE__ */ React5.createElement(EGDSSpacing, {
            margin: {
                inline: type === "mobile" ? "six" : "unset"
            }
        }, /* @__PURE__ */ React5.createElement(EGDSCard, {
            border: true
        }, /* @__PURE__ */ React5.createElement(EGDSLayoutGrid, {
            columns: type === "mobile" ? 1 : 12,
            space: "two"
        }, data.image && /* @__PURE__ */ React5.createElement(EGDSLayoutGridItem, {
            colSpan: type === "mobile" ? 12 : 3
        }, /* @__PURE__ */ React5.createElement(EGDSFigure, null, "className= ", type === "mobile" ? "uitk-figure--mobile" : "uitk-figure--desktop", /* @__PURE__ */ React5.createElement(EGDSImage, {
            alt: (_data_image = data.image) === null || _data_image === void 0 ? void 0 : _data_image.description,
            src: (_data_image1 = data.image) === null || _data_image1 === void 0 ? void 0 : _data_image1.url,
            placeholderImage: true
        }))), /* @__PURE__ */ React5.createElement(EGDSLayoutGridItem, {
            colSpan: type === "mobile" ? 12 : 9
        }, /* @__PURE__ */ React5.createElement(EGDSCardContentSection, null, /* @__PURE__ */ React5.createElement(EGDSLayoutFlex, {
            direction: "column"
        }, /* @__PURE__ */ React5.createElement(EGDSHeading, {
            size: 5,
            tag: "h2"
        }, (_data_heading = data.heading) === null || _data_heading === void 0 ? void 0 : _data_heading.text), /* @__PURE__ */ React5.createElement(EGDSText2, {
            size: 400,
            spacing: "four"
        }, (_data_body = data.body) === null || _data_body === void 0 ? void 0 : _data_body.text, " ", data.inLineLink && /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement("span", null, " "), /* @__PURE__ */ React5.createElement(EGDSLink, {
            inline: true,
            onClickCapture: onLinkClick
        }, /* @__PURE__ */ React5.createElement("a", {
            href: data.inLineLink.action.resource.value
        }, data.inLineLink.text))))), /* @__PURE__ */ React5.createElement(EGDSSpacing, {
            margin: {
                blockstart: "four"
            }
        }, /* @__PURE__ */ React5.createElement(EGDSLayoutFlex, {
            justifyContent: "start"
        }, /* @__PURE__ */ React5.createElement(EGDSLayoutFlexItem, null, data.button && /* @__PURE__ */ React5.createElement(EGDSButton, {
            data: data.button
        })))))))));
    };
    return /* @__PURE__ */ React5.createElement(Viewport, null, /* @__PURE__ */ React5.createElement(ViewLarge, null, renderMreBannerView({
        type: "desktop"
    })), /* @__PURE__ */ React5.createElement(ViewSmall, null, renderMreBannerView({
        type: "mobile"
    })));
};
MreBannerView.displayName = "MreBannerView";
MreBannerView.fragment = mreBannerViewFragment;
// src/components/mre-banner/banner.tsx
var __Query = gql9(_templateObject8(), EGDSStylizedText.fragment, EGDSStandardLink.fragment, fragment, EGDSButton.fragment);
var MreBannerComponent = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.mreQuery)) {
        return null;
    }
    return /* @__PURE__ */ React6.createElement("div", null, /* @__PURE__ */ React6.createElement(MreBannerView, {
        data: data.mreQuery
    }));
};
MreBannerComponent.displayName = "sharedui-MREBanner";
export { MreBannerComponent };
//# sourceMappingURL=index.js.map